import { Component, Input } from "@angular/core";
import { Development } from "@models/development.model";
import { Project } from "@models/project.model";

@Component({
  selector: "app-development-project-budget",
  templateUrl: "./development-project-budget.component.html",
  styleUrls: ["./development-project-budget.component.scss"],
})
export class DevelopmentProjectBudgetComponent {
  @Input()
  set development(development: Development) {
    this._development = development;
    if (this._development) this.generateProjects();
  }

  get development(): Development {
    return this._development;
  }

  _development!: Development;
  projectBudgetDetails: Project[] = [];

  fiveYearCapitalNeeds = 0;
  twentyYearCapitalNeeds = 0;

  generateProjects(): void {
    this.projectBudgetDetails = this._development?.areasOfWork
      .map((a) => {
        this.fiveYearCapitalNeeds += a.fiveYearCapitalNeeds;
        this.twentyYearCapitalNeeds += a.twentyYearCapitalNeeds;

        return a.projects;
      })
      .flat();
  }
}
